import { jsx } from "@emotion/react/jsx-runtime";
import useFormField from "./useFormField.mjs";
import { Typography } from "@wsui/base";
function FormFieldDescription(_ref) {
  let {
    ...restProps
  } = _ref;
  const {
    description,
    id
  } = useFormField();
  if (!description) {
    return null;
  }
  return /* @__PURE__ */jsx(Typography, {
    variant: "description",
    id: `${id}-description`,
    ...restProps,
    children: description
  });
}
export { FormFieldDescription as default };